import type { ApiClient } from '../client';

// Set the «Entrega»'s new pickup expiration date («Ampliar custodia» — the panel's fifth WRITE and
// its first parameterized one). The id rides the path (url-encoded); the client attaches the
// Firebase token via the Authorization header. The body carries a DATE ONLY (`YYYY-MM-DD`), with no
// instant and no timezone conversion — the one format that keeps timezone arithmetic out of the
// write path, interpreted in the «buzón»'s timezone by the backend. ADR 0011 governs rendering, not
// writing, which is why the format is stated here. Empty 200 — nothing to parse; the caller
// refetches the detail, whose «Expira la recogida» row and «Ampliada» badge are the effect.
// ⚠️ Proposed shape, unverified against app-service (AS-035) — mirror the delivered one on arrival.
export async function extendCustody(
  client: ApiClient,
  id: string,
  expirationDate: string,
): Promise<void> {
  await client.post(`/app_service/panel/v1/deliveries/${encodeURIComponent(id)}/extend-expiration`, {
    expiration_date: expirationDate,
  });
}
